export interface ContactInformationData {
  emailContact: string;
}
